<template>
  <div v-loading="loading">
    <div v-if="isSecurity">
     <div v-if="xml" class="content">
      <el-button type="warning" plain @click="shengcehng"
        >重新生成该报告</el-button
      >
      <!-- 个人信用报告 -->
      <table border>
        <caption style="font-size: 18px">
          个人信用报告
        </caption>
        <tr>
          <td colspan="3" style="text-align: left">
            报告编号：{{ zxData.PRH.PA01.PA01A.PA01AI01 }}
          </td>
          <td colspan="2" style="text-align: right">
            报告时间：{{ zxData.PRH.PA01.PA01A.PA01AR01 }}
          </td>
        </tr>
        <tr>
          <th>被查询者姓名</th>
          <th>被查询证件类型</th>
          <th>被查询证件号码</th>
          <th>查询机构</th>
          <th>查询原因</th>
        </tr>
        <tr>
          <td>{{ zxData.PRH.PA01.PA01B.PA01BQ01 }}</td>
          <td>{{ zxData.PRH.PA01.PA01B.PA01BD01 | sfzType }}</td>
          <td>{{ zxData.PRH.PA01.PA01B.PA01BI01 }}</td>
          <td>{{ zxData.PRH.PA01.PA01B.PA01BI02 }}</td>
          <td>{{ zxData.PRH.PA01.PA01B.PA01BD02 | cxyy }}</td>
          <!-- 查询原因 -->
        </tr>
      </table>
      <div style="height: 25px"></div>
      <!-- 异议信息提示 -->
      <table border>
        <tr>
          <th>异议信息提示</th>
        </tr>
        <tr>
          <td>
            信息主体对信用报告内容提出了
            {{ zxData.PRH.PA01.PA01E.PA01ES01 }}
            笔异议且正在处理中，请浏览时注意阅读相关内容。
          </td>
        </tr>
      </table>
      <div style="height: 25px"></div>
      <table border>
        <caption style="font-size: 18px">
          一、个人基本信息
        </caption>
        <caption class="biaot">
          （一）身份信息
        </caption>
        <tr>
          <th>性别</th>
          <th>出生日期</th>
          <th>婚姻状况</th>
          <th>学历</th>
          <th>学位</th>
          <th>就业状况</th>
          <th>国籍</th>
          <th>电子邮箱</th>
        </tr>
        <tr>
          <td>{{ zxData.PIM.PB01.PB01A.PB01AD01 | xb }}</td>
          <!-- 性别 -->
          <td>{{ zxData.PIM.PB01.PB01A.PB01AR01 ? zxData.PIM.PB01.PB01A.PB01AR01 : '一'}}</td>
          <td>{{ zxData.PMM.PB02.PB020D01 | hyzk }}</td>
          <td>{{ zxData.PIM.PB01.PB01A.PB01AD02 | xl }}</td>
          <td>{{ zxData.PIM.PB01.PB01A.PB01AD03 | xw }}</td>
          <td>{{ zxData.PIM.PB01.PB01A.PB01AD04 | jyzk }}</td>
          <td>{{ zxData.PIM.PB01.PB01A.PB01AD05 ? zxData.PIM.PB01.PB01A.PB01AD05 : '一'}}</td>
          <td>{{ zxData.PIM.PB01.PB01A.PB01AQ01 ? zxData.PIM.PB01.PB01A.PB01AQ01 : '一'}}</td>
        </tr>
        <tr>
          <th colspan="4">通讯地址</th>
          <th colspan="4">户籍地址</th>
        </tr>
        <tr>
          <td colspan="4">{{ zxData.PIM.PB01.PB01A.PB01AQ02 ? zxData.PIM.PB01.PB01A.PB01AQ02 : '一'}}</td>
          <td colspan="4">{{ zxData.PIM.PB01.PB01A.PB01AQ03 ? zxData.PIM.PB01.PB01A.PB01AQ03 :'一'}}</td>
        </tr>
        <tr>
          <th>编号</th>
          <th colspan="3">手机号码</th>
          <th colspan="4">信息更新日期</th>
        </tr>
        <template v-if="Array.isArray(zxData.PIM.PB01.PB01B.PB01BH)">
          <tr
            v-for="(item, index) in zxData.PIM.PB01.PB01B.PB01BH"
            :key="index"
          >
            <td>{{ index + 1 }}</td>
            <td colspan="3">{{ item.PB01BQ01 ? item.PB01BQ01 : '一'}}</td>
            <td colspan="4">{{ item.PB01BR01 ? item.PB01BR01 : '一'}}</td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td>1</td>
            <td colspan="3">{{ zxData.PIM.PB01.PB01B.PB01BH ? zxData.PIM.PB01.PB01B.PB01BH.PB01BQ01 : '一'}}</td>
            <td colspan="4">{{ zxData.PIM.PB01.PB01B.PB01BH ? zxData.PIM.PB01.PB01B.PB01BH.PB01BR01 : '一'}}</td>
          </tr>
        </template>
      </table>
      <!-- (二)居住信息 -->
      <div style="height: 25px"></div>
      <table border>
        <caption class="biaot">
          (二)居住信息
        </caption>
        <tr>
          <th colspan="3">编号</th>
          <th>居住地址</th>
          <th>住宅电话</th>
          <th>居住状况</th>
          <th>信息更新日期</th>
        </tr>
        <tr v-for="(item, index) in zxData.PRM.PB03" :key="index">
          <td>{{ index + 1 }}</td>
          <td colspan="3">{{ item.PB030Q01 ? item.PB030Q01 : "一" }}</td>
          <td>{{ item.PB030Q02 ? item.PB030Q02 : "一" }}</td>
          <td>{{ item.PB030D01 | jzzk }}</td>
          <td>{{ item.PB030R01 ? item.PB030R01 : "一" }}</td>
        </tr>
      </table>
      <!-- (三)职业信息 -->
      <div style="height: 25px"></div>
      <table border>
        <caption class="biaot">
          (三)职业信息
        </caption>
        <tr>
          <th>编号</th>
          <th colspan="2">工作单位</th>
          <th>单位性质</th>
          <th colspan="2">单位地址</th>
          <th>单位电话</th>
        </tr>
        <template v-if="zxData.POM">
          <template v-if="Array.isArray(zxData.POM.PB04)">
            <tr v-for="(item, index) in zxData.POM.PB04" :key="index">
              <td>{{ index + 1 }}</td>
              <td colspan="2">{{ item.PB040Q01 }}</td>
              <td>一</td>
              <td colspan="2">{{ item.PB040Q02 ? item.PB040Q02 : "一" }}</td>
              <td>{{ item.PB040Q03 ? item.PB040Q03 : "一" }}</td>
            </tr>
            <tr>
              <th>编号</th>
              <th>职业</th>
              <th>行业</th>
              <th>职务</th>
              <th>职称</th>
              <th>进入本单位年份</th>
              <th>信息更新日期</th>
            </tr>
            <tr v-for="(item, index) in zxData.POM.PB04" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.PB040D04 | zy }}</td>
              <td>{{ item.PB040D03 | hy }}</td>
              <td>{{ item.PB040D05 | zw }}</td>
              <td>{{ item.PB040D06 | zc }}</td>
              <td>{{ item.PB040R01 ? item.PB040R01 : "一" }}</td>
              <td>{{ item.PB040R02 }}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td>1</td>
              <td colspan="2">{{ zxData.POM.PB04.PB040Q01 }}</td>
              <td>一</td>
              <td colspan="2">
                {{ zxData.POM.PB04.PB040Q02 ? zxData.POM.PB04.PB040Q02 : "一" }}
              </td>
              <td>
                {{ zxData.POM.PB04.PB040Q03 ? zxData.POM.PB04.PB040Q03 : "一" }}
              </td>
            </tr>
            <tr>
              <th>编号</th>
              <th>职业</th>
              <th>行业</th>
              <th>职务</th>
              <th>职称</th>
              <th>进入本单位年份</th>
              <th>信息更新日期</th>
            </tr>
            <tr>
              <td>1</td>
              <td>{{ zxData.POM.PB04.PB040D04 | zy }}</td>
              <td>{{ zxData.POM.PB04.PB040D03 | hy }}</td>
              <td>{{ zxData.POM.PB04.PB040D05 | zw }}</td>
              <td>{{ zxData.POM.PB04.PB040D06 | zc }}</td>
              <td>
                {{ zxData.POM.PB04.PB040R01 ? zxData.POM.PB04.PB040R01 : "一" }}
              </td>
              <td>{{ zxData.POM.PB04.PB040R02 }}</td>
            </tr>
          </template>
        </template>
      </table>
      <!-- 二 信息概要 -->
      <div style="height: 25px"></div>
      <table border>
        <caption style="font-size: 18px">
          二、 信息概要
        </caption>
        <caption class="biaot">
          (一)信贷交易信息提示
        </caption>
        <tr>
          <th>业务类型</th>
          <th>账户数</th>
          <th>首笔业务发放月份</th>
        </tr>
        <tr v-for="(item, index) in zxData.PCO.PC02.PC02A.PC02AH">
          <td>{{ item.PC02AD01 | ywlx }}</td>
          <td>{{ item.PC02AS03 ? item.PC02AS03 : "一" }}</td>
          <td>{{ item.PC02AR01 ? item.PC02AR01 : "一" }}</td>
        </tr>
        <tr>
          <th>合计</th>
          <td>{{ zxData.PCO.PC02.PC02A.PC02AS01 }}</td>
        </tr>
      </table>
      <!-- 二 信贷交易违约信息概要 -->
      <div style="height: 25px"></div>
      <table border>
        <caption class="biaot">
          (二)信贷交易违约信息概要
        </caption>
        <tr>
          <th colspan="5">逾期（透支）信息汇总</th>
        </tr>
        <tr>
          <th>账户类型</th>
          <th>账户数</th>
          <th>月份数</th>
          <th>单月最高逾期/透支总额</th>
          <th>最长逾期/透支月数</th>
        </tr>
        <tr v-for="(item, index) in zxData.PCO.PC02.PC02D.PC02DH" :key="index">
          <th>{{ item.PC02DD01 | yqtz }}</th>
          <td>{{ item.PC02DS02 ? item.PC02DS02 : "一" }}</td>
          <td>{{ item.PC02DS03 ? item.PC02DS03 : "一" }}</td>
          <td>{{ item.PC02DJ01 ? item.PC02DJ01 : "一" }}</td>
          <td>{{ item.PC02DS04 ? item.PC02DS04 : "一" }}</td>
        </tr>
      </table>
      <!-- 查询记录概要 -->
      <table border>
        <caption class="biaot">
          （三）查询记录概要
        </caption>
        <tr>
          <th colspan="3">上次查询记录</th>
        </tr>
        <tr>
          <td>{{ zxData.PQO.PC05.PC05A.PC05AR01 }}</td>
          <td>{{ zxData.PQO.PC05.PC05A.PC05AD01 }}</td>
          <td>{{ zxData.PQO.PC05.PC05A.PC05AQ01 }}</td>
        </tr>
      </table>
      <div style="height: 25px"></div>
      <table border>
        <tr>
          <th colspan="2">最近一个月内的查询机构数</th>
          <th colspan="3">最近一个月内的查询次数</th>
          <th colspan="3">最近2年内的查询次数</th>
        </tr>
        <tr>
          <th>贷款审批</th>
          <th>信用卡审批</th>
          <th>贷款审批</th>
          <th>信用卡审批</th>
          <th>本人查询</th>
          <th>贷后管理</th>
          <th>担保资格审查</th>
          <th>特约商户实名审查</th>
        </tr>
        <tr>
          <td>{{ zxData.PQO.PC05.PC05B.PC05BS01 }}</td>
          <td>{{ zxData.PQO.PC05.PC05B.PC05BS02 }}</td>
          <td>{{ zxData.PQO.PC05.PC05B.PC05BS03 }}</td>
          <td>{{ zxData.PQO.PC05.PC05B.PC05BS04 }}</td>
          <td>{{ zxData.PQO.PC05.PC05B.PC05BS05 }}</td>
          <td>{{ zxData.PQO.PC05.PC05B.PC05BS06 }}</td>
          <td>{{ zxData.PQO.PC05.PC05B.PC05BS07 }}</td>
          <td>{{ zxData.PQO.PC05.PC05B.PC05BS08 }}</td>
        </tr>
      </table>
      <!-- 信贷交易授信及负债信息概要 -->
      <table border>
        <caption class="biaot">
          （四）信贷交易授信及负债信息概要
        </caption>
        <tr>
          <th colspan="5">非循环贷账户汇总信息</th>
        </tr>
        <tr>
          <th>管理机构数</th>
          <th>账户数</th>
          <th>授信总额</th>
          <th>余额</th>
          <th>最近6个月平均应还款</th>
        </tr>
        <tr>
          <td>
            {{
              zxData.PCO.PC02.PC02E.PC02ES01
                ? zxData.PCO.PC02.PC02E.PC02ES01
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02E.PC02ES02
                ? zxData.PCO.PC02.PC02E.PC02ES02
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02E.PC02EJ01
                ? zxData.PCO.PC02.PC02E.PC02EJ01
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02E.PC02EJ02
                ? zxData.PCO.PC02.PC02E.PC02EJ02
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02E.PC02EJ03
                ? zxData.PCO.PC02.PC02E.PC02EJ03
                : "一"
            }}
          </td>
        </tr>
      </table>
      <div style="height: 25px"></div>
      <table border>
        <tr>
          <th colspan="5">循环贷账户汇总信息</th>
        </tr>
        <tr>
          <th>管理机构数</th>
          <th>账户数</th>
          <th>授信总额</th>
          <th>余额</th>
          <th>最近6个月平均应还款</th>
        </tr>
        <tr>
          <td>
            {{
              zxData.PCO.PC02.PC02G.PC02GS01
                ? zxData.PCO.PC02.PC02G.PC02GS01
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02G.PC02GS02
                ? zxData.PCO.PC02.PC02G.PC02GS02
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02G.PC02GJ01
                ? zxData.PCO.PC02.PC02G.PC02GJ01
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02G.PC02GJ03
                ? zxData.PCO.PC02.PC02G.PC02GJ03
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02G.PC02EJ03
                ? zxData.PCO.PC02.PC02G.PC02EJ03
                : "一"
            }}
          </td>
        </tr>
      </table>
      <div style="height: 25px"></div>
      <table border>
        <tr>
          <th colspan="7">贷记卡账户信息汇总</th>
        </tr>
        <tr>
          <th>发卡机构数</th>
          <th>账户数</th>
          <th>授信总额</th>
          <th>单家机构最高授信额</th>
          <th>单家机构最低授信额</th>
          <th>已用额度</th>
          <th>最近6个月平均使用额度</th>
        </tr>
        <tr>
          <td>
            {{
              zxData.PCO.PC02.PC02H.PC02HS01
                ? zxData.PCO.PC02.PC02H.PC02HS01
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02H.PC02HS02
                ? zxData.PCO.PC02.PC02H.PC02HS02
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02H.PC02HJ01
                ? zxData.PCO.PC02.PC02H.PC02HJ01
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02H.PC02HJ02
                ? zxData.PCO.PC02.PC02H.PC02HJ02
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02H.PC02HJ03
                ? zxData.PCO.PC02.PC02H.PC02HJ03
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02H.PC02HJ04
                ? zxData.PCO.PC02.PC02H.PC02HJ04
                : "一"
            }}
          </td>
          <td>
            {{
              zxData.PCO.PC02.PC02H.PC02HJ05
                ? zxData.PCO.PC02.PC02H.PC02HJ05
                : "一"
            }}
          </td>
        </tr>
      </table>

      <!-- 三信贷交易信息明细 -->
      <template v-if="Array.isArray(zxData.PDA.PD01)">
        <template v-for="(item, index) in zxData.PDA.PD01">
        <!-- <table border> -->
        <table border v-if="item.PD01A.PD01AD01 == 'D1'">
          <caption v-if="index == 0" style="font-size: 18px">
            三、信贷交易信息明细
          </caption>
          <caption class="biaot" v-if="index == 0">
            (一)非循环贷账户
          </caption>
          <caption style="text-align: left;font-size:14px;">
            {{
              item.PD01A.PD01AI01
            }}
          </caption>
          <tr>
            <th colspan="2">管理机构</th>
            <th colspan="2">账户标识</th>
            <th colspan="2">开立期日</th>
            <th colspan="3">到期日期</th>
            <th colspan="2">借款金额</th>
            <th colspan="2">账户币种</th>
          </tr>
          <tr>
            <td colspan="2">
              {{ item.PD01A.PD01AD02 | jsType }}"{{ item.PD01A.PD01AI02 }}"
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AI03 ? item.PD01A.PD01AI03 : "一" }}
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AR01 ? item.PD01A.PD01AR01 : "一" }}
            </td>
            <td colspan="3">
              {{ item.PD01A.PD01AR02 ? item.PD01A.PD01AR02 : "一" }}
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AJ01 ? item.PD01A.PD01AJ01 : "一" }}
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AD04 | bizhong }}
            </td>
          </tr>
          <tr>
            <th colspan="2">业务种类</th>
            <th colspan="2">担保方式</th>
            <th colspan="2">还款期数</th>
            <th colspan="3">还款频率</th>
            <th colspan="2">还款方式</th>
            <th colspan="2">共同借款标志</th>
          </tr>
          <tr>
            <td colspan="2">{{ item.PD01A.PD01AD03 | ywzl }}</td>
            <td colspan="2">
              {{ item.PD01A.PD01AD07 | dbfs }}
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AS01 ? item.PD01A.PD01AS01 : "一" }}
            </td>
            <td colspan="3">{{ item.PD01A.PD01AD06 | hkpl }}</td>
            <td colspan="2">
              {{ item.PD01A.PD01AD05 ? item.PD01A.PD01AD05 : "一" }}
            </td>
            <td colspan="2">{{ item.PD01A.PD01AD09 | gtjkbz }}</td>
          </tr>
          <tr v-if="item.PD01E.PD01ER02">
            <th colspan="13" class="huank">截止{{ item.PD01E.PD01ER02 }}</th>
          </tr>

          <!-- 新加 -->
          <tr>
            <th colspan="7">账户状态</th>
            <th colspan="6">账户关闭日期</th>
          </tr>
          <tr v-if="item.PD01B">
            <td colspan="7">{{item.PD01B.PD01BD01 | zhtzD1}}</td>
            <td colspan="6">{{item.PD01B.PD01BR01 ? item.PD01B.PD01BR01 : '一'}}</td>
          </tr>

          <!-- 新加账户余额 -->
          <template v-if="item.PD01C">
            <tr>
              <th colspan="2">账户状态</th>
              <th>五级分类</th>
              <th colspan="2">余额</th>
              <th colspan="2">剩余还款期数</th>
              <th colspan="2">本月应还款</th>
              <th colspan="2">应还款日</th>
              <th colspan="2">本月实还款</th>
            </tr>
            <tr>
              <td colspan="2">{{item.PD01C.PD01CD01 | fxh}}</td>
              <td>{{item.PD01C.PD01CD02 | wjfl}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ01 ? item.PD01C.PD01CJ01 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CS01 ? item.PD01C.PD01CS01 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ04 ? item.PD01C.PD01CJ04 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CR02 ? item.PD01C.PD01CR02 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ05 ? item.PD01C.PD01CJ05 : '一'}}</td>
            </tr>
            <tr>
              <th colspan="2">最近一次还款日期</th>
              <th>当前逾期数</th>
              <th colspan="2">当前逾期总额</th>
              <th colspan="2">逾期31-60天未还本金</th>
              <th colspan="2">逾期61-90天未还本金</th>
              <th colspan="2">逾期91-180天未还本金</th>
              <th colspan="2">逾期180天以上未还本金</th>
            </tr>
            <tr>
              <td colspan="2">{{item.PD01C.PD01CR03 ? item.PD01C.PD01CR03 : '一'}}</td>
              <td>{{item.PD01C.PD01CS02 ? item.PD01C.PD01CS02 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ06 ? item.PD01C.PD01CJ06 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ07 ? item.PD01C.PD01CJ07 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ08 ? item.PD01C.PD01CJ08 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ09 ? item.PD01C.PD01CJ09 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ10 ? item.PD01C.PD01CJ10 : '一'}}</td>
            </tr>
          </template>
          <!-- 新加账户余额截至 -->

          <tr v-if="item.PD01E.PD01ER01">
            <th colspan="13" class="hunk">
              {{ item.PD01E.PD01ER01 }}到{{ item.PD01E.PD01ER02 }}的还款记录
            </th>
          </tr>
          <tr v-if="typess[index] != ''">
            <th></th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
            <th>10</th>
            <th>11</th>
            <th>12</th>
          </tr>
          <template v-if="typess[index] != ''">
            <template v-for="(item, index) in typess[index]">
              <tr>
                <td rowspan="2" class="xunh">{{item | timess}}</td>
                <td v-for="res in item" class="xunh">{{ res ? res.PD01ED01 : ''}}</td>
              </tr>
              <tr>
                <td v-for="res in item" class="xunh">{{ res ? res.PD01EJ01 : ''}}</td>
              </tr>
            </template>
          </template>
        </table>
      </template>
      <p style="text-align:center;font-weight:bold;margin-top:10px" class="biaot" v-if="xunhuan(zxData.PDA)">(二)非循环贷账户</p>
      <template v-for="(item, index) in zxData.PDA.PD01">
        <table border v-if="item.PD01A.PD01AD01 == 'R1'">
          <caption style="text-align: left;font-size:14px;" >
            {{
              item.PD01A.PD01AI01
            }}
          </caption>
          <tr>
            <th colspan="2">管理机构</th>
            <th colspan="2">账户标识</th>
            <th colspan="3">开立期日</th>
            <th colspan="2">到期日期</th>
            <th colspan="2">借款金额</th>
            <th colspan="2">账户币种</th>
          </tr>
          <tr>
            <td colspan="2">
              {{ item.PD01A.PD01AD02 | jsType }}"{{ item.PD01A.PD01AI02 }}"
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AI03 ? item.PD01A.PD01AI03 : "一" }}
            </td>
            <td colspan="3">
              {{ item.PD01A.PD01AR01 ? item.PD01A.PD01AR01 : "一" }}
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AR02 ? item.PD01A.PD01AR02 : "一" }}
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AJ01 ? item.PD01A.PD01AJ01 : "一" }}
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AD04 | bizhong }}
            </td>
          </tr>
          <tr>
            <th colspan="2">业务种类</th>
            <th colspan="2">担保方式</th>
            <th colspan="3">还款期数</th>
            <th colspan="2">还款频率</th>
            <th colspan="2">还款方式</th>
            <th colspan="2">共同借款标志</th>
          </tr>
          <tr>
            <td colspan="2">{{ item.PD01A.PD01AD03 | ywzl }}</td>
            <td colspan="2">
              {{ item.PD01A.PD01AD07 ? item.PD01A.PD01AD07 : "一" }}
            </td>
            <td colspan="3">
              {{ item.PD01A.PD01AS01 ? item.PD01A.PD01AS01 : "一" }}
            </td>
            <td colspan="2">{{ item.PD01A.PD01AD06 | hkpl }}</td>
            <td colspan="2">
              {{ item.PD01A.PD01AD05 ? item.PD01A.PD01AD05 : "一" }}
            </td>
            <td colspan="2">{{ item.PD01A.PD01AD09 | gtjkbz }}</td>
          </tr>
          <tr v-if="item.PD01E.PD01ER02">
            <th colspan="13" class="huank">截止{{ item.PD01E.PD01ER02 }}</th>
          </tr>
          <!-- 新加 -->
          <tr>
            <th colspan="6">账户状态</th>
            <th colspan="7">账户关闭日期</th>
          </tr>
          <tr v-if="item.PD01B">
            <td colspan="6">{{item.PD01B.PD01BD01 | zhtzR1}}</td>
            <td colspan="7">{{item.PD01B.PD01BR01 ? item.PD01B.PD01BR01 : '一'}}</td>
          </tr>
          <!-- 新加账户余额 -->
          <template v-if="item.PD01C">
            <tr>
              <th colspan="2">账户状态</th>
              <th>五级分类</th>
              <th colspan="2">余额</th>
              <th colspan="2">剩余还款期数</th>
              <th colspan="2">本月应还款</th>
              <th colspan="2">应还款日</th>
              <th colspan="2">本月实还款</th>
            </tr>
            <tr>
              <td colspan="2">{{item.PD01C.PD01CD01 | fxh}}</td>
              <td>{{item.PD01C.PD01CD02 | wjfl}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ01 ? item.PD01C.PD01CJ01 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CS01 ? item.PD01C.PD01CS01 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ04 ? item.PD01C.PD01CJ04 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CR02 ? item.PD01C.PD01CR02 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ05 ? item.PD01C.PD01CJ05 : '一'}}</td>
            </tr>
            <tr>
              <th colspan="2">最近一次还款日期</th>
              <th>当前逾期数</th>
              <th colspan="2">当前逾期总额</th>
              <th colspan="2">逾期31-60天未还本金</th>
              <th colspan="2">逾期61-90天未还本金</th>
              <th colspan="2">逾期91-180天未还本金</th>
              <th colspan="2">逾期180天以上未还本金</th>
            </tr>
            <tr>
              <td colspan="2">{{item.PD01C.PD01CR03 ? item.PD01C.PD01CR03 : '一'}}</td>
              <td>{{item.PD01C.PD01CS02 ? item.PD01C.PD01CS02 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ06 ? item.PD01C.PD01CJ06 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ07 ? item.PD01C.PD01CJ07 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ08 ? item.PD01C.PD01CJ08 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ09 ? item.PD01C.PD01CJ09 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ10 ? item.PD01C.PD01CJ10 : '一'}}</td>
            </tr>
          </template>
          <!-- 新加账户余额截至 -->
          <tr v-if="item.PD01E.PD01ER01">
            <th colspan="13" class="hunk">
              {{ item.PD01E.PD01ER01 }}到{{ item.PD01E.PD01ER02 }}的还款记录
            </th>
          </tr>
          <tr v-if="typess[index] != ''">
            <th></th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
            <th>10</th>
            <th>11</th>
            <th>12</th>
          </tr>
          <template v-if="typess[index] != ''">
            <template v-for="(item, index) in typess[index]">
              <tr>
                <td rowspan="2" class="xunh">{{item | timess}}</td>
                <td v-for="res in item" class="xunh">{{ res ? res.PD01ED01 : ''}}</td>
              </tr>
              <tr>
                <td v-for="res in item" class="xunh"> {{ res ? res.PD01EJ01 : ''}}</td>
              </tr>
            </template>
          </template>
        </table>
      </template>
      <p style="text-align:center;font-weight:bold;margin-top:10px" class="biaot" v-if="xunhuan1(zxData.PDA)">(三) 贷记卡账户</p>
      <template v-for="(item, index) in zxData.PDA.PD01">
        <table border v-if="item.PD01A.PD01AD01 == 'R2'">
          <caption style="text-align: left;font-size:14px;">
            {{
              item.PD01A.PD01AI01
            }}
          </caption>
          <tr>
            <th colspan="2">管理机构</th>
            <th colspan="2">账户标识</th>
            <th colspan="3">开立期日</th>
            <th colspan="2">到期日期</th>
            <th colspan="2">借款金额</th>
            <th colspan="2">账户币种</th>
          </tr>
          <tr>
            <td colspan="2">
              {{ item.PD01A.PD01AD02 | jsType }}"{{ item.PD01A.PD01AI02 }}"
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AI03 ? item.PD01A.PD01AI03 : "一" }}
            </td>
            <td colspan="3">
              {{ item.PD01A.PD01AR01 ? item.PD01A.PD01AR01 : "一" }}
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AR02 ? item.PD01A.PD01AR02 : "一" }}
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AJ01 ? item.PD01A.PD01AJ01 : "一" }}
            </td>
            <td colspan="2">
              {{ item.PD01A.PD01AD04 | bizhong }}
            </td>
          </tr>
          <tr>
            <th colspan="2">业务种类</th>
            <th colspan="2">担保方式</th>
            <th colspan="3">还款期数</th>
            <th colspan="2">还款频率</th>
            <th colspan="2">还款方式</th>
            <th colspan="2">共同借款标志</th>
          </tr>
          <tr>
            <td colspan="2">{{ item.PD01A.PD01AD03 | ywzl }}</td>
            <td colspan="2">
              {{ item.PD01A.PD01AD07 | dbfs }}
            </td>
            <td colspan="3">
              {{ item.PD01A.PD01AS01 ? item.PD01A.PD01AS01 : "一" }}
            </td>
            <td colspan="2">{{ item.PD01A.PD01AD06 | hkpl }}</td>
            <td colspan="2">
              {{ item.PD01A.PD01AD05 ? item.PD01A.PD01AD05 : "一" }}
            </td>
            <td colspan="2">{{ item.PD01A.PD01AD09 | gtjkbz }}</td>
          </tr>
          <tr v-if="item.PD01E.PD01ER02">
            <th colspan="13" class="huank">截止{{ item.PD01E.PD01ER02 }}</th>
          </tr>
          <!-- 新加 -->
          <tr>
            <th colspan="6">账户状态</th>
            <th colspan="7">账户关闭日期</th>
          </tr>
          <tr v-if="item.PD01B">
            <td colspan="6">{{item.PD01B.PD01BD01 | zhtzR2}}</td>
            <td colspan="7">{{item.PD01B.PD01BR01}}</td>
          </tr>
           <!-- 新加账户余额 -->
           <template v-if="item.PD01C">
            <tr>
              <th colspan="2">账户状态</th>
              <th>五级分类</th>
              <th colspan="2">余额</th>
              <th colspan="2">剩余还款期数</th>
              <th colspan="2">本月应还款</th>
              <th colspan="2">应还款日</th>
              <th colspan="2">本月实还款</th>
            </tr>
            <tr>
              <td colspan="2">{{item.PD01C.PD01CD01 | fxh}}</td>
              <td>{{item.PD01C.PD01CD02 | wjfl}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ01 ? item.PD01C.PD01CJ01 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CS01 ? item.PD01C.PD01CS01 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ04 ? item.PD01C.PD01CJ04 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CR02 ? item.PD01C.PD01CR02 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ05 ? item.PD01C.PD01CJ05 : '一'}}</td>
            </tr>
            <tr>
              <th colspan="2">最近一次还款日期</th>
              <th>当前逾期数</th>
              <th colspan="2">当前逾期总额</th>
              <th colspan="2">逾期31-60天未还本金</th>
              <th colspan="2">逾期61-90天未还本金</th>
              <th colspan="2">逾期91-180天未还本金</th>
              <th colspan="2">逾期180天以上未还本金</th>
            </tr>
            <tr>
              <td colspan="2">{{item.PD01C.PD01CR03 ? item.PD01C.PD01CR03 : '一'}}</td>
              <td>{{item.PD01C.PD01CS02 ? item.PD01C.PD01CS02 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ06 ? item.PD01C.PD01CJ06 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ07 ? item.PD01C.PD01CJ07 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ08 ? item.PD01C.PD01CJ08 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ09 ? item.PD01C.PD01CJ09 : '一'}}</td>
              <td colspan="2">{{item.PD01C.PD01CJ10 ? item.PD01C.PD01CJ10 : '一'}}</td>
            </tr>
          </template>
          <!-- 新加账户余额截至 -->
          <tr v-if="item.PD01E.PD01ER01">
            <th colspan="13" class="hunk">
              {{ item.PD01E.PD01ER01 }}到{{ item.PD01E.PD01ER02 }}的还款记录
            </th>
          </tr>
          <tr v-if="typess[index] != ''">
            <th></th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
            <th>10</th>
            <th>11</th>
            <th>12</th>
          </tr>
          <template v-if="typess[index] != ''">
            <template v-for="(item, index) in typess[index]">
              <!-- <tr>
                <th v-for="res in item">
                  {{ res.PD01ER03 }}
                </th>
              </tr> -->
              <tr>
                <td rowspan="2" class="xunh">{{item | timess}}</td>
                <td v-for="res in item" class="xunh">{{ res ? res.PD01ED01 : ''}}</td>
              </tr>
              <tr>
                <td v-for="res in item" class="xunh">{{ res ? res.PD01EJ01 : ''}}</td>
              </tr>
            </template>
          </template>
        </table>
      </template>
      </template>
      <template v-else>
        <template v-if="zxData.PDA.PD01.PD01C">
          <table border>
            <caption style="font-size: 18px">
              三、信贷交易信息明细
            </caption>
            <caption class="biaot" v-if="zxData.PDA.PD01.PD01A.PD01AD01 == 'D1'">
              (一)非循环贷账户
            </caption>
            <caption class="biaot" v-else-if="zxData.PDA.PD01.PD01A.PD01AD01 == 'R1'">
              (二)非循环贷账户
            </caption>
            <caption class="biaot" v-else-if="zxData.PDA.PD01.PD01A.PD01AD01 == 'R2'">
              (三) 贷记卡账户
            </caption>
            <caption style="text-align: left;font-size:14px;">
              {{
                zxData.PDA.PD01.PD01A.PD01AI01
              }}
            </caption>
            <tr>
              <th colspan="2">管理机构</th>
              <th colspan="2">账户标识</th>
              <th colspan="2">开立期日</th>
              <th colspan="3">到期日期</th>
              <th colspan="2">借款金额</th>
              <th colspan="2">账户币种</th>
            </tr>
            <tr>
              <td colspan="2">
                {{ zxData.PDA.PD01.PD01A.PD01AD02 | jsType }}"{{ zxData.PDA.PD01.PD01A.PD01AI02 }}"
              </td>
              <td colspan="2">
                {{ zxData.PDA.PD01.PD01A.PD01AI03 ? zxData.PDA.PD01.PD01A.PD01AI03 : "一" }}
              </td>
              <td colspan="2">
                {{ zxData.PDA.PD01.PD01A.PD01AR01 ? zxData.PDA.PD01.PD01A.PD01AR01 : "一" }}
              </td>
              <td colspan="3">
                {{ zxData.PDA.PD01.PD01A.PD01AR02 ? zxData.PDA.PD01.PD01A.PD01AR02 : "一" }}
              </td>
              <td colspan="2">
                {{ zxData.PDA.PD01.PD01A.PD01AJ01 ? zxData.PDA.PD01.PD01A.PD01AJ01 : "一" }}
              </td>
              <td colspan="2">
                {{ zxData.PDA.PD01.PD01A.PD01AD04 | bizhong }}
              </td>
            </tr>
            <tr>
              <th colspan="2">业务种类</th>
              <th colspan="2">担保方式</th>
              <th colspan="2">还款期数</th>
              <th colspan="3">还款频率</th>
              <th colspan="2">还款方式</th>
              <th colspan="2">共同借款标志</th>
            </tr>
            <tr>
              <td colspan="2">{{ zxData.PDA.PD01.PD01A.PD01AD03 | ywzl }}</td>
              <td colspan="2">
                {{ zxData.PDA.PD01.PD01A.PD01AD07 | dbfs }}
              </td>
              <td colspan="2">
                {{ zxData.PDA.PD01.PD01A.PD01AS01 ? zxData.PDA.PD01.PD01A.PD01AS01 : "一" }}
              </td>
              <td colspan="3">{{ zxData.PDA.PD01.PD01A.PD01AD06 | hkpl }}</td>
              <td colspan="2">
                {{ zxData.PDA.PD01.PD01A.PD01AD05 ? zxData.PDA.PD01.PD01A.PD01AD05 : "一" }}
              </td>
              <td colspan="2">{{ zxData.PDA.PD01.PD01A.PD01AD09 | gtjkbz }}</td>
            </tr>
            <tr v-if="zxData.PDA.PD01.PD01E.PD01ER02">
              <th colspan="13" class="huank">截止{{ zxData.PDA.PD01.PD01E.PD01ER02 }}</th>
            </tr>

            <!-- 新加 -->
            <tr>
              <th colspan="7">账户状态</th>
              <th colspan="6">账户关闭日期</th>
            </tr>
            <tr v-if="zxData.PDA.PD01.PD01B">
              <td colspan="7">{{zxData.PDA.PD01.PD01B.PD01BD01 | zhtzD1}}</td>
              <td colspan="6">{{zxData.PDA.PD01.PD01B.PD01BR01 ? zxData.PDA.PD01.PD01B.PD01BR01 : '一'}}</td>
            </tr>
              <tr>
              <th colspan="2">账户状态</th>
              <th>五级分类</th>
              <th colspan="2">余额</th>
              <th colspan="2">剩余还款期数</th>
              <th colspan="2">本月应还款</th>
              <th colspan="2">应还款日</th>
              <th colspan="2">本月实还款</th>
            </tr>
            <tr>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CD01 | fxh}}</td>
              <td>{{zxData.PDA.PD01.PD01C.PD01CD02 | wjfl}}</td>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CJ01 ? zxData.PDA.PD01.PD01C.PD01CJ01 : '一'}}</td>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CS01 ? zxData.PDA.PD01.PD01C.PD01CS01 : '一'}}</td>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CJ04 ? zxData.PDA.PD01.PD01C.PD01CJ04 : '一'}}</td>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CR02 ? zxData.PDA.PD01.PD01C.PD01CR02 : '一'}}</td>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CJ05 ? zxData.PDA.PD01.PD01C.PD01CJ05 : '一'}}</td>
            </tr>
            <tr>
              <th colspan="2">最近一次还款日期</th>
              <th>当前逾期数</th>
              <th colspan="2">当前逾期总额</th>
              <th colspan="2">逾期31-60天未还本金</th>
              <th colspan="2">逾期61-90天未还本金</th>
              <th colspan="2">逾期91-180天未还本金</th>
              <th colspan="2">逾期180天以上未还本金</th>
            </tr>
            <tr>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CR03 ? zxData.PDA.PD01.PD01C.PD01CR03 : '一'}}</td>
              <td>{{zxData.PDA.PD01.PD01C.PD01CS02 ? zxData.PDA.PD01.PD01C.PD01CS02 : '一'}}</td>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CJ06 ? zxData.PDA.PD01.PD01C.PD01CJ06 : '一'}}</td>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CJ07 ? zxData.PDA.PD01.PD01C.PD01CJ07 : '一'}}</td>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CJ08 ? zxData.PDA.PD01.PD01C.PD01CJ08 : '一'}}</td>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CJ09 ? zxData.PDA.PD01.PD01C.PD01CJ09 : '一'}}</td>
              <td colspan="2">{{zxData.PDA.PD01.PD01C.PD01CJ10 ? zxData.PDA.PD01.PD01C.PD01CJ10 : '一'}}</td>
            </tr>
            </table>
          </template>
      </template>
      
      <div style="height: 25px"></div>
      <table border>
        <caption style="font-size: 18px">
          四、查询记录
        </caption>
        <tr>
          <th>编号</th>
          <th>查询日期</th>
          <th>查询机构</th>
          <th>查询原因</th>
        </tr>
        <template v-if="Array.isArray(zxData.POQ.PH01)">
          <tr v-for="(item, index) in zxData.POQ.PH01">
            <td>{{ index + 1 }}</td>
            <td>{{ item.PH010R01 }}</td>
            <td>{{ item.PH010Q02 }}</td>
            <td>{{ item.PH010Q03 | cxyy }}</td>
          </tr>
        </template>
        <template v-else>
          <td>1</td>
          <td>{{ zxData.POQ.PH01.PH010R01 }}</td>
          <td>{{ zxData.POQ.PH01.PH010Q02 }}</td>
          <td>{{ zxData.POQ.PH01.PH010Q03 | cxyy}}</td>
        </template>
      </table>
      <div style="width: 50%; margin: 0 auto">
        <p style="text-align: center; font-size: 15px; font-weight: bold">
          报告说明
        </p>
        1.本报告由中国人民银行征信中心出具，依据截至报告时点的个人征信系统记录的信息生成。除查询记录外，其他信息均由相关机构提供，征信中心不保证其真实性和准确性，但承诺在信息汇总、加工、整合的全过程中保持客观、中立的地位。
        2.本报告的信贷交易信息提示中，“业务类型”为“其他”的汇总信息不包含“资产处置”和“垫款”业务。
        3.本报告中如果没有“信贷交易违约信息概要”信息，说明信息主体最近5年内没有逾期。
        4.对于存在授信限额的协议信息，信息主体的可用额度需结合“授信协议信息”中的授信额度、授信限额信息和余额进行估算。
        5.本报告中的信贷交易授信及负债信息概要展示未结清/未销户的授信及负债信息。由于存在不同类型的账户共享授信额度的情况，汇总之和可能大于明细加总，因此不能通过简单加总循环额度下分账户、循环贷账户、贷记卡账户、准贷记卡账户信息汇总中的授信总额来计算总授信额。
        6.本报告的借贷交易明细信息中，循环贷账户的到期日期是指账户授信额度的到期日期。
        7.本报告的借贷交易明细信息中，借贷账户（除被追偿信息外）展示最近5年的还款情况，包括当前还款状态和当前逾期总额（对于准贷记卡账户，指透支余额）。当前还款状态为“#”、当前逾期总额为“--”，都代表具体值未知。
        8.对于通过自助渠道办理的“小额、高频”业务，金融机构将合并报送相关账户，展示在本报告的借贷交易明细信息中；此时账户的还款方式为“不区分还款方式”，该账户的还款频率统一约定为“月”，“还款期数”按月计算，其还款信息按月进行观测和更新。
        9.本报告的信息概要的逾期信息汇总中，准贷记卡账户只包含透支超过60
        天以上的账户。 10.本报告中的还款期数为“--”是指该账户是非分期还款。
        11.本报告不展示5年前已经结束的违约行为，以及5年前的欠税记录、强制执行记录、民事判决记录、行政处罚记录、电信欠费记录。
        12.机构说明是数据提供机构对具体业务添加的特别说明信息。
        13.本人声明是信息主体对信用报告中的信息所附注的简要说明，信息主体对本人声明的真实性负责。
        14.异议标注是征信中心添加的，用于说明信息主体对信用报告中的哪些信息有异议。
        15.本报告内容涉及个人隐私，查询者应依法使用、妥善保管。因使用不当造成个人信息泄露的，征信中心将不承担相关责任。
        16.除“有相关还款责任的企业借款”中的金额展示对应币种金额外，本报告中所有金额均为折合人民币金额。
        17.本报告整合了数据提供机构以信息主体不同证件报送的信息。
      </div>
    </div>
    <div v-else-if="zxid2 != ''">
      <el-button type="warning" plain @click="shengcehng"
        >重新生成该报告</el-button
      >
      <div
        style="
          font-size: 15px;
          display: flex;
          justify-content: space-between;
          margin: 15px 0;
        "
      >
        <span>报告编号: {{ serialNo }}</span>
        <span> </span>
      </div>

      <div class="diyihang">
        状态:<span class="lanse">{{ remark }}</span>
      </div>
      <div style="display: flex">
        <div class="num">
          <div class="card" v-for="(item, index) in list" :key="index">
            {{ item.value }}
            :
            <span>{{ listdata[item.name] }} </span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="bgelse">
      <div class="tishi">提示：请生成报告后再查看该报告！</div>
      <div class="baogao">征信报告没有生成</div>
      <div class="shhengcheng">
        <el-button
          type="warning"
          plain
          @click="shouquan"
          v-if="!hrzx_authorization"
          >生成个人授权书</el-button
        >
        <el-button type="warning" plain @click="shengcehng" v-else
          >生成该报告</el-button
        >
      </div>
    </div>
    </div>
    <div v-else>
      <div class="warning_info">提示：请充值！</div>
    </div>
   
  </div>
</template>

<script>
import FengkongApi from "@/api/fengkong.js";
import OrderApi from "@/api/order.js";
import isSecurity from "@/utils/isSecurity.js";
export default {
  props: ["order_id", "user_id", "list", "zxid2", "hrzx_authorization", "xml"],
  data() {
    return {
      isSecurity: true, // 查看消费金额是否超过充值金额
      loading: false,
      zfzxData2: "",
      listdata: "",
      serialNo: "",
      remark: "",
      zxData: "",
      arrs: "",
      zhType: "",
      typess: "",
    };
  },
  computed: {
    xunhuan1(){
      return (e)=>{
        let bool = ''
        if(e.PD01){
          e.PD01.forEach((item,index)=>{
            if(item.PD01A.PD01AD01=='R2'){
              bool = true
            }
          })
          return bool
        }else{
          return false
        }
        
      }
    },
    xunhuan(){
      return (e)=>{
        let bool = ''
        if(e.PD01){
          e.PD01.forEach((item,index)=>{
            if(item.PD01A.PD01AD01=='R1'){
              bool = true
            }
          })
          return bool
        }else{
          return false
        }
        
      }
    },
    yuear() {
      return (e, b, c) => {
        if (e && b) {
          let yar = "";
          let yars = "";
          yar = e.split("-")[0];
          yars = b.split("-")[0];
          return yars - yar + 1;
        } else {
          return 0;
        }
      };
    },
  },
  beforeCreate() {
    const self = this;
    isSecurity().then(result => {
      console.log(result);
      self.isSecurity = result;
    });
  },
  created() {
    const self = this;

    if (this.zxid2) {
      var data = JSON.parse(this.zxid2);
      this.remark = data.data.remark;
      this.serialNo = data.data.serialNo;
      let item = JSON.parse(data.data.report);
      let newboj = {};
      for (let i = 0; i < item.length; i++) {
        newboj[item[i].name] = item[i].value;
      }
      this.listdata = newboj;
    }
    const xml = this.$x2js.xml2js(this.xml); //解析
    this.zxData = xml.Document;
    console.log(this.zxData,'zxData')
    this.chuli();
  },

  methods: {
    readAuth(self) {
      console.log('获取合同', self.hrzx_authorization)
      if (self.hrzx_authorization) {
        fetch(self.hrzx_authorization, { type: "GET" }).then( res => console.log(res));
      }
    },
    chuli() {
      // 处理一维数组
      let data = [];
      // 处理二维数组
      let erData = [];
      // 处理时间
      let a = [];
      let time = "";
      if (this.zxData.PDA.PD01) {
        if(Array.isArray(this.zxData.PDA.PD01)){
          this.zxData.PDA.PD01.forEach((item) => {
          if (item.PD01E.PD01EH) {
            if (Array.isArray(item.PD01E.PD01EH)) {
              item.PD01E.PD01EH.forEach((res, index) => {
                // 初始化时间
                let datas = res.PD01ER03.split("-")[0];
                if (index == 0) {
                  time = datas;
                }
                // 处理相同时间的数组
                if (time == datas) {
                  erData.push(res);
                } else {
                  // 上一个时间
                  a.push(erData);
                  // 清空上个时间的数据
                  erData = [];
                  time = datas;
                  erData.push(res);
                }
              });
              a.push(erData);
              erData = [];
              data.push(a);
              a = [];
            } else {
              data.push(0);
            }
          } else {
            data.push(0);
          }
        });
        }else{
          
        }
        
      }
      data.forEach((item,index)=>{
        if(item!=0 && item){
          let arrs = []
          for(let i = 0; i < item.length;i++){
            let arr1 = Array(12)
            for(let k = 0; k < item[i].length; k++){
             let num = Number(item[i][k].PD01ER03.split('-')[1])
              arr1[num-1] = item[i][k]
            }
            arrs.push(arr1)
          }
          data[index] = arrs
          arrs = []
        }

      })
      this.typess = data;
    },
    async shouquan() {
      let self = this;
      
      const BAI_RON = 'zhangqian';
      const param = { type: BAI_RON, order_id: this.order_id };
      // api.hrzxqs({ order_id: this.order_id }); // old func
      await FengkongApi.createAuthorization(param, true);
      self.$parent.getParams();
      this.$message.success("已生成授权书");
    },

    shengcehng() {
      let self = this;
      self
        .$confirm("确认生成征信报告, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          self.loading = true;
          let param = {
            order_id: self.order_id,
            user_id: self.user_id,
          };
          FengkongApi.trade(param, true)
            .then((res) => {
              self.$parent.getParams();
              self.$message({
                message: "生成成功",
                type: "success",
              });
              self.loading = false;
            })
            .catch((error) => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  filters: {
    timess(item){
      let data = ''
      item.forEach(i=>{
        if(i){
         data = i.PD01ER03.split('-')[0]
        }
      })
      return data
    },
    // 账户状态D1
    zhtzD1(e){
      if(e==1){
        return '正常'
      }else if(e==2){
        return '逾期'
      }else if(e==3){
        return '结清'
      }else{
        return '一'
      }
    },
    // 账户状态R1
    zhtzR1(e){
      if(e==1){
        return '正常'
      }else if(e==2){
        return '逾期'
      }else if(e==3){
        return '结清'
      }else if(e==4){
        return '呆账'
      }else if(e==5){
        return '银行止付'
      }else if(e==6){
        return '担保物不足'
      }else if(e==8){
        return '司法追偿'
      }else{
        return '一'
      }
    },
    // 账户状态R2
    zhtzR2(e){
      if(e==1){
        return '正常'
      }else if(e==2){
        return '冻结'
      }else if(e==3){
        return '止付'
      }else if(e==4){
        return '销户'
      }else if(e==5){
        return '呆账'
      }else if(e==6){
        return '未激活'
      }else if(e==8){
        return '司法追偿'
      }else if(e==31){
        return '银行止付'
      }else{
        return '一'
      }
    },
    // 五级分类
    wjfl(e){
      if(e==1){
        return '正常'
      }else if(e==2){
        return '关注'
      }else if(e==3){
        return '次级'
      }else if(e==4){
        return '可疑'
      }else if(e==5){
        return '损失'
      }else if(e==9){
        return '未分类'
      }else{
        return '一'
      }
    },
    // 担保方式
    dbfs(e) {
      if (e == 1) {
        return "质押";
      } else if (e == 2) {
        return "抵押";
      } else if (e == 3) {
        return "保证";
      } else if (e == 4) {
        return "信用/无担保";
      } else if (e == 5) {
        return "组合(含保证)";
      } else if (e == 6) {
        return "组合（不含保证）";
      } else if (e == 7) {
        return "农户联保";
      } else if (e == 9) {
        return "其他";
      } else {
        return "一";
      }
    },
    // 币种
    bizhong(e) {
      if (e == "CNY") {
        return "人民币";
      } else if (e == "USD") {
        return "美元";
      } else {
        return "一";
      }
    },
    // 机构类型
    jsType(e) {
      if (e == 11) {
        return "商业银行";
      } else if (e == 12) {
        return "村镇银行";
      } else if (e == 14) {
        return "住房储蓄银行";
      } else if (e == 15) {
        return "外资银行";
      } else if (e == 16) {
        return "财务公司";
      } else if (e == 21) {
        return "信托公司";
      } else if (e == 22) {
        return "融资租赁公司";
      } else if (e == 23) {
        return "汽车金融公司";
      } else if (e == 24) {
        return "消费金融公司";
      } else if (e == 25) {
        return "贷款公司";
      } else if (e == 26) {
        return "金融资产管理公司";
      } else if (e == 31) {
        return "证券公司";
      } else if (e == 41) {
        return "保险公司";
      } else if (e == 51) {
        return "小额贷款公司";
      } else if (e == 52) {
        return "公积金管理中心";
      } else if (e == 53) {
        return "融资担保公司";
      } else if (e == 99) {
        return "其他机构";
      } else {
        return "一";
      }
    },
    isArr(e) {
      console.log(e, "kkkkkkkkk");
    },
    fxh(e) {
      if (e == 1) {
        return "正常";
      } else if (e == 2) {
        return "逾期";
      } else if (e == 3) {
        return "结清";
      } else if (e == 4) {
        return "呆账";
      } else if (e == 5) {
        return "转出";
      } else if (e == 6) {
        return "担保物不足";
      } else if (e == 7) {
        return "强制平仓";
      } else if (e == 8) {
        return "司法追偿";
      } else {
        return "一";
      }
    },
    // 共同借款标准
    gtjkbz(e) {
      if (e == 0) {
        return "无";
      } else if (e == 1) {
        return "主借款人";
      } else if (e == 2) {
        return "从借款人";
      } else {
        return "一";
      }
    },
    // 还款频率
    hkpl(e) {
      if (e == "01") {
        return "日";
      } else if (e == "02") {
        return "周";
      } else if (e == "03") {
        return "月";
      } else if (e == "04") {
        return "季";
      } else if (e == "05") {
        return "半年";
      } else if (e == "06") {
        return "年";
      } else if (e == "07") {
        return "一次性";
      } else if (e == "08") {
        return "不定期";
      } else if (e == "12") {
        return "旬";
      } else if (e == "13") {
        return "双周";
      } else if (e == "14") {
        return "其他";
      } else {
        return "一";
      }
    },
    // 业务种类
    ywzl(e) {
      if (e == 11) {
        return "个人住房商业贷款";
      } else if (e == 12) {
        return "个人商用房（含商住两用）贷款";
      } else if (e == 13) {
        return "个人住房公积金贷款";
      } else if (e == 21) {
        return "个人汽车消费贷款";
      } else if (e == 31) {
        return "个人助学贷款";
      } else if (e == 32) {
        return "国家助学贷款";
      } else if (e == 33) {
        return "商业助学贷款";
      } else if (e == 41) {
        return "个人经营性贷款";
      } else if (e == 51) {
        return "农户贷款";
      } else if (e == 52) {
        return "经营性农户贷款";
      } else if (e == 53) {
        return "消费性农户贷款";
      } else if (e == 91) {
        return "其他个人消费贷款";
      } else if (e == 99) {
        return "其他贷款";
      } else if (e == 71) {
        return "准贷记卡";
      } else if (e == 81) {
        return "贷记卡";
      } else if (e == 82) {
        return "大额专项分期卡";
      } else if (e == 61) {
        return "约定购回式证券交易";
      } else if (e == 62) {
        return "股票质押式回购交易";
      } else if (e == 63) {
        return "融资融券业务";
      } else if (e == 64) {
        return "其他证券类融资";
      } else if (e == 92) {
        return "融资租赁业务";
      } else if (e == "A1") {
        return "资产处置";
      } else if (e == "B1") {
        return "代偿债务";
      } else {
        return "一";
      }
    },
    // 逾期透支
    yqtz(e) {
      if (e == 1) {
        return "非循环贷账户";
      } else if (e == 2) {
        return "循环额度下分账户";
      } else if (e == 3) {
        return " 循环贷账户";
      } else if (e == 4) {
        return " 贷记卡账户";
      } else if (e == 5) {
        return " 准贷记卡账户";
      }
    },
    // 业务贷款类型
    ywlx(e) {
      if (e == 11) {
        return "个人住房贷款";
      } else if (e == 12) {
        return "个人商用房（包括商住两用房）贷款";
      } else if (e == 19) {
        return "其他类贷款";
      } else if (e == 21) {
        return "贷记卡";
      } else if (e == 22) {
        return "准贷记卡";
      } else if (e == 99) {
        return "其他";
      }
    },
    // 职称
    zc(e) {
      if (e === 0) {
        return "无";
      } else if (e == 1) {
        return "高级";
      } else if (e == 2) {
        return "中级";
      } else if (e == 3) {
        return "初级";
      } else if (e == 9) {
        return "未知";
      } else {
        return "一";
      }
    },
    // 职务
    zw(e) {
      if (e == 1) {
        return "高级领导";
      } else if (e == 2) {
        return "中级领导";
      } else if (e == 3) {
        return "一般员工";
      } else if (e == 4) {
        return "其他";
      } else if (e == 9) {
        return "未知";
      } else {
        return "一";
      }
    },
    // 行业
    hy(e) {
      if (e == "A") {
        return "农、林、牧、渔业";
      } else if (e == "B") {
        return "采矿业";
      } else if (e == "C") {
        return "制造业";
      } else if (e == "D") {
        return "电力、热力、燃气及水生产和供应业";
      } else if (e == "E") {
        return "建筑业";
      } else if (e == "F") {
        return "批发和零售业";
      } else if (e == "G") {
        return "交通运输、仓储和邮储业";
      } else if (e == "H") {
        return "住宿和餐饮业";
      } else if (e == "I") {
        return "信息传输、软件和信息技术服务业";
      } else if (e == "J") {
        return "金融业";
      } else if (e == "K") {
        return "房地产业";
      } else if (e == "L") {
        return "租赁和商务服务业";
      } else if (e == "M") {
        return "科学研究和技术服务业";
      } else if (e == "N") {
        return "水利、环境和公共设施管理业";
      } else if (e == "O") {
        return "居民服务、修理和其他服务业";
      } else if (e == "P") {
        return "教育";
      } else if (e == "Q") {
        return "卫生和社会工作";
      } else if (e == "R") {
        return "文化、体育和娱乐业";
      } else if (e == "S") {
        return "公共管理、社会保障和社会组织";
      } else if (e == "T") {
        return "国际组织";
      } else {
        return "未知";
      }
    },
    // 职业
    zy(e) {
      if (e === 0) {
        return "国家机关、党群组织、企业、事业单位负责人";
      } else if (e == 1) {
        return "专业技术人员";
      } else if (e == 3) {
        return "办事人员和有关人员";
      } else if (e == 4) {
        return "商业、服务业人员";
      } else if (e == 5) {
        return "农、林、牧、渔、水利业生产人员";
      } else if (e == 6) {
        return "生产、运输设备操作人员及有关人员";
      } else if (e == "X") {
        return "军人";
      } else if (e == "Y") {
        return "不便分类的其他从业人员";
      } else if (e == "Z") {
        return "未知";
      } else {
        return "一";
      }
    },
    // 居住状况
    jzzk(e) {
      if (e == 1) {
        return "自置";
      } else if (e == 2) {
        return "按揭";
      } else if (e == 3) {
        return "亲属楼宇";
      } else if (e == 4) {
        return "集体宿舍";
      } else if (e == 5) {
        return "租房";
      } else if (e == 6) {
        return "共有住宅";
      } else if (e == 7) {
        return "其他";
      } else if (e == 11) {
        return "自有";
      } else if (e == 12) {
        return "借住";
      } else if (e == 9) {
        return "未知";
      } else {
        return "一";
      }
    },
    // 就业状况
    jyzk(e) {
      if (e == 11) {
        return "国家公务员";
      } else if (e == 13) {
        return "专业技术人员";
      } else if (e == 17) {
        return "职员";
      } else if (e == 21) {
        return "企业管理人员";
      } else if (e == 24) {
        return "工人";
      } else if (e == 27) {
        return "农民";
      } else if (e == 31) {
        return "学生";
      } else if (e == 37) {
        return "现役军人";
      } else if (e == 51) {
        return "自由职业者";
      } else if (e == 54) {
        return "个体经营者";
      } else if (e == 70) {
        return "无业人员";
      } else if (e == 80) {
        return "退（离）休人员";
      } else if (e == 90) {
        return "其他";
      } else if (e == 91) {
        return "在职";
      } else if (e == 99) {
        return "未知";
      }
    },
    // 学位
    xw(e) {
      if (e == 0) {
        return "其他";
      } else if (e == 1) {
        return "名誉博士";
      } else if (e == 2) {
        return "博士";
      } else if (e == 3) {
        return "硕士";
      } else if (e == 4) {
        return "学士";
      } else if (e == 5) {
        return "无";
      } else if (e == 9) {
        return "未知";
      }
    },
    // 学历
    xl(e) {
      if (e == 10) {
        return "研究生";
      } else if (e == 20) {
        return "本科";
      } else if (e == 30) {
        return "大专";
      } else if (e == 40) {
        return "中专，职高，技校";
      } else if (e == 60) {
        return "高中";
      } else if (e == 90) {
        return "其他";
      } else if (e == 91) {
        return "初中及以下";
      } else if (e == 99) {
        return "未知";
      }
    },
    // 婚姻状况
    hyzk(e) {
      if (e == 10) {
        return "未婚";
      } else if (e == 20) {
        return "已婚";
      } else if (e == 30) {
        return "丧偶";
      } else if (e == 40) {
        return "离婚";
      } else if (e == 91) {
        return "单身";
      } else if (e == 99) {
        return "未知";
      }
    },
    // 性别
    xb(val) {
      if (val == 0) {
        return "未知";
      } else if (val == 1) {
        return "男";
      } else if (val == 2) {
        return "女";
      } else {
        return "未知";
      }
    },
    // 身份证
    sfzType(item) {
      if (item == 1) {
        return "户口簿";
      } else if (item == 2) {
        return "护照";
      } else if (item == 5) {
        return "港澳居民来往内地通行证";
      } else if (item == 6) {
        return "台湾同胞来往大陆通行证";
      } else if (item == 8) {
        return "外国人居留证";
      } else if (item == "A") {
        return "香港身份证";
      } else if (item == 9) {
        return "警官证";
      } else if (item == "B") {
        return "澳门身份证";
      } else if (item == "C") {
        return "台湾身份证";
      } else if (item == "X") {
        return "其他证件";
      } else if (item == 10) {
        return "身份证";
      } else if (item == 20) {
        return "军人身份证件";
      }
    },
    // 查询原因
    cxyy(item) {
      if (item == "08") {
        return "担保资格审查";
      } else if (item == "01") {
        return "贷后管理";
      } else if (item == "02") {
        return "贷款审批";
      } else if (item == "03") {
        return "信用卡审批";
      } else if (item == "09") {
        return "司法调查";
      } else if (item == "16") {
        return "公积金提取复核查询";
      } else if (item == "18") {
        return "股指期货开户";
      } else if (item == "19") {
        return "特约商户实名审查";
      } else if (item == "20") {
        return "保前审查";
      } else if (item == "21") {
        return "保后管理";
      } else if (item == "22") {
        return "法人代表、负责人、高管等资信审查";
      } else if (item == "23") {
        return "客户准入资格审查";
      } else if (item == "24") {
        return "融资审批";
      } else if (item == "25") {
        return "资信审查";
      } else if (item == "26") {
        return "额度审批";
      }
    },
    // 过滤器
    formatDate(create_time1) {
      let date = new Date(create_time1);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
    },
  },
};
</script>
  
<style scoped>
caption {
  height: 40px;
  line-height: 40px;
  font-weight: bold;
}
table {
  margin: 0 auto;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border: 2px solid #808080;
}
th {
  height: 40px;
  font-size: 16px;
  border: 2px solid #808080;
}
td {
  text-align: center;
  height: 35px;
  font-size: 16px;
  border: 2px solid #808080;
}
.num {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}

.num .card {
  width: 33%;
  padding: 5px;
  border: 1px solid #efefef;
  font-size: 25px;
}

.num .card span {
  font-weight: bold;
}

.content {
  width: 100%;
  padding: 25px 33px 46px;
  background-color: #f5f6f8;
}

.diyihang {
  text-align: center;
  margin: 20px;
  font-size: 25px;
  width: 100%;
}

.lanse {
  color: #1890ff;
}

.biaoge {
  border-collapse: collapse;
  width: 100%;
}
.yue th {
  width: 5%;
}
.biaoge1 {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;
}
.hunk{
  font-size: 13px;
}
.biaot{
  font-size: 16px;
}
.xunh{
  font-weight: bold;
}
</style>
  


// WEBPACK FOOTER //
// src/views/fengkong/operation/detail7.vue